import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Vendordashboard from "./Vendordashboard";
import Salesdashboard from "./Salesdashboard";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
const handleCall= (childData) => {
        // Update the name in the component's state
		let strpageval=childData.split('~');
      
	
    }
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Sales" {...a11yProps(0)} />
          <Tab label="Vendor" {...a11yProps(1)} />
   
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
     <Salesdashboard parentdasCallback={handleCall}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
     <Vendordashboard parentdasCallback={handleCall}/>
      </CustomTabPanel>
     
    </Box>
  );
}

